export default {
  note: {
    title: 'Besondere Hinweise:',
    description:
      'Wir geben unser Bestes, um Wünsche zu berücksichtigen, aber können keine Änderungen vornehmen, die den Preis beeinflussen.',
    placeholder: 'Sonderwunsch hinzufügen',
  },
  buttons: {
    update_item: 'Aktualisieren',
    add_to_card: 'Hinzufügen',
    add: '+ Artikel',
  },
  alcohol_warning: 'Dies ist ein Artikel mit Altersbeschränkung.',
  caffeine_warning: 'Erhöhter Koffeingehalt. Für Kinder und schwangere oder stillende Frauen nicht empfohlen.{{value}}',
  error_messages: {
    product_unavailable: 'Ausverkauft!',
    item_not_added: 'Der Artikel konnte nicht hinzugefügt werden. Versuche es erneut.',
  },
  success_messages: {
    item_added: 'Artikel erfolgreich hinzugefügt',
  },
};
